export enum BrowserActionTypes {
  STORE_INFO = "@@BROWSER/STORE_INFO",
}
